var map = {
	"./gong-xi-fa-cai-reg.m4a": [
		99,
		99
	],
	"./hong-bao-reg.m4a": [
		769,
		769
	],
	"./ni-hao-reg.m4a": [
		959,
		959
	],
	"./xie-xie-reg.m4a": [
		464,
		464
	],
	"./xin-nian-kuai-le-reg.m4a": [
		366,
		250
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 376;
module.exports = webpackAsyncContext;